import { graphql } from "../__generated__/gql";

export const GET_DOWNLOADS_DATA_QUERY = graphql(`
  query GetDownloadsData {
    downloadsTable {
      tableId
      tableName
      tableDataType
      repo
      complexityData
      productLevel
      facet
      yearMin
      yearMax
      displayName
      productClassificationHs92
      productClassificationHs12
      productClassificationHs22
      productClassificationSitc
      productClassificationServicesUnilateral
      dvFileId
      dvFileName
      dvFileSize
      dvPublicationDate
      doi
      columns {
        columnId
        columnName
        complexity
        description
        decimalPlaces
        dataType
        notes
      }
    }
  }
`);

export default GET_DOWNLOADS_DATA_QUERY;
